/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"

import { getColor } from "../utils"

// Helper functions
const getScoreColor = value => ({
  color: getColor(value)
})

const cutOffAfterDash = str =>
  str
    // Only take first word in hyphentated string
    // Do this until we shorten behavior names
    .split("-")[0]

class ScoreDetails extends Component {
  render() {
    const { data } = this.props

    const numberRows = Math.round(data.length / 2)

    const columnStyle = () => {
      return {
        height: `${175 / numberRows}px`,
        width: "100%"
      }
    }

    const rowBody = (item, index, indexOriginal) => {
      if (index === indexOriginal + 1 || index === indexOriginal) {
        return (
          <div className="col-md-6 col-sm-6 no-padding" key={`sd-rb-${index}`}>
            <div style={columnStyle()}>
              <div className="scores-display-text">
                {cutOffAfterDash(item.behavior)}
              </div>
              <div
                className="scores-display-score"
                style={getScoreColor(item.score)}
              >
                {item.score}
              </div>
            </div>
          </div>
        )
      }
    }

    const divBody = (_row, indexOriginal) => {
      if (indexOriginal === 0 || indexOriginal === 2 || indexOriginal === 4) {
        return (
          <div className="row equal row-eq-height" key={`sd-${indexOriginal}`}>
            {data.map((item, index) => {
              return (
                <Fragment key={`sd-db-${index}`}>
                  {rowBody(item, index, indexOriginal)}
                </Fragment>
              )
            })}
          </div>
        )
      }
    }

    return (
      <div className="card score-display-height">
        <div className="container">
          {data.map((row, index) => {
            return (
              <Fragment key={`sd-${index}`}>{divBody(row, index)}</Fragment>
            )
          })}
        </div>
      </div>
    )
  }
}

export default ScoreDetails

ScoreDetails.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      behavior: PropTypes.string,
      score: PropTypes.number
    })
  )
}

ScoreDetails.defaultProps = {
  data: []
}
